import {
  SET_APP_DECIMAL,
  SET_APP_TITLE,
  SET_APP_NAME_TITLE,
  TOGGLE_DRAWER,
  SET_BANDED_ROWS,
  SET_GRID_VERTICAL_LINES,
  SET_GRID_FONT_SIZE,
  SET_GRID_ROW_HEIGHT,
  SET_HIDE_GRID_SIDE_BAR,
  SET_GRID_HEADER_HEIGHT, SET_LOAD_DATA_ON_LAUNCH,
  SET_GRID_LEVEL_LABELS, SET_SHOW_GRID_LEVEL_COUNT,
  SET_DEFAULT_EXPANSION, SET_LISTEN_SCENARIO_APP_TALK
} from './actions';
import { produce } from 'immer';

const defaultState = {
  drawerOpen: true,
  appTitle: 'Portfolio Analytics',
  appNameTitle: '',
  loadDataOnLaunch: true,
  appDecimal: 3,
  bandedRows: true,
  gridVerticalLines: true,
  gridLevelLabels: true,
  showGridLevelCount: true,
  gridFontSize: 12,
  gridRowHeight: 22,
  gridHeaderHeight: 65,
  hideGridSideBar: false,
  defaultExpansion: 2,
  listenScenarioAppTalk: false,
};

export default produce((state = defaultState, action) => {
  switch (action.type) {
    case TOGGLE_DRAWER: {
      state.drawerOpen = action.override !== undefined ? action.override : !state.drawerOpen;
      break;
    }
    case SET_APP_DECIMAL: {
      state.appDecimal = action.appDecimal;
      break;
    }
    case SET_APP_TITLE: {
      state.appTitle = action.appTitle;
      break;
    }
    case SET_APP_NAME_TITLE: {
      state.appNameTitle = action.appNameTitle;
      break;
    }

    case SET_LOAD_DATA_ON_LAUNCH: {
      state.loadDataOnLaunch = action.payload;
      break;
    }
    case SET_GRID_LEVEL_LABELS: {
      state.gridLevelLabels = action.gridLevelLabels;
      break;
    }
    case SET_SHOW_GRID_LEVEL_COUNT: {
      state.showGridLevelCount = action.showGridLevelCount;
      break;
    }
    case SET_BANDED_ROWS: {
      state.bandedRows = action.bandedRows;
      break;
    }
    case SET_GRID_VERTICAL_LINES: {
      state.gridVerticalLines = action.gridVerticalLines;
      break;
    }
    case SET_GRID_FONT_SIZE: {
      state.gridFontSize = action.gridFontSize;
      break;
    }
    case SET_GRID_ROW_HEIGHT: {
      state.gridRowHeight = action.gridRowHeight;
      break;
    }
    case SET_GRID_HEADER_HEIGHT: {
      state.gridHeaderHeight = action.gridHeaderHeight;
      break;
    }
    case SET_HIDE_GRID_SIDE_BAR: {
      state.hideGridSideBar = action.value;
      break;
    }
    case SET_DEFAULT_EXPANSION: {
      state.defaultExpansion = action.defaultExpansion;
      break;
    }
    case SET_LISTEN_SCENARIO_APP_TALK: {
      state.listenScenarioAppTalk = action.value;
      break;
    }
    default:
      return state;
  }
});
